import * as React from 'react';

import { FormattedHTMLMessage } from 'js/lib/coursera.react-intl';

import Notification from 'bundles/notification-center/components/Notification';
import type {
  EnrolledProgramWithCourseNames as EnrolledProgramWithCourseNamesType,
  Notification as NotificationType,
} from 'bundles/notification-center/types';
import formatCourseList from 'bundles/notification-center/util/formatCourseList';
import { getEnterpriseRouteForCourseProducts } from 'bundles/unified-description-page-common/utils/getRouteForCourseProducts';

import _t from 'i18n!nls/notification-center';

type Props = {
  notification: EnrolledProgramWithCourseNamesType;
  onClick: (notification: NotificationType) => void;
};

const EnrolledProgramWithCourseNames = ({ notification, onClick }: Props) => {
  const href =
    notification.data.courses.length === 1
      ? getEnterpriseRouteForCourseProducts(
          // @ts-expect-error TS2532 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
          notification.data.courses[0].slug,
          notification.data.programSlug,
          // @ts-expect-error TS2532 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
          notification.data.courses[0].type
        )
      : `/programs/${notification.data.programSlug}/my-learning`;
  return (
    <Notification notification={notification} href={href} onClick={onClick}>
      <FormattedHTMLMessage
        message={_t('Your organization enrolled you in <b>{courseList}</b>')}
        courseList={formatCourseList(notification.data.courses)}
      />
    </Notification>
  );
};

export default EnrolledProgramWithCourseNames;
